import bgMain from "../assets/images/loading/bg_main.png.png";
import loadingImageDefault from "../assets/images/loading/loading_image_01_default.png.png";
import loadingImageComplete from "../assets/images/loading/loading_image_01_complete.png.png";
import loadingImageTrack from "../assets/images/loading/loading_image_02.png.png";
import loadingLogo from "../assets/images/loading/loading_logo.png.png";
import "./LoadingScreen.css";

export default function LoadingScreen({progress}) {
    const safeProgress = Math.max(0, Math.min(100, progress));
    const isComplete = safeProgress >= 100;

    return (
        <div className="loading-screen" role="status" aria-live="polite" aria-label={`页面加载中 ${safeProgress}%`}>
            <img className="loading-bg" src={bgMain} alt="" aria-hidden="true"/>
            <div className="loading-panel">
                <div className={isComplete ? "loading-images is-complete" : "loading-images"} style={{"--loading-progress": `${safeProgress}%`}}>
                    <img className="loading-track" src={loadingImageTrack} alt="" aria-hidden="true"/>
                    <img className="loading-default" src={loadingImageDefault} alt="" aria-hidden="true"/>
                    <img className="loading-complete" src={loadingImageComplete} alt="" aria-hidden="true"/>
                    <img className="loading-logo" src={loadingLogo} alt="" aria-hidden="true"/>
                </div>
            </div>
        </div>
    );
}
